import { useCallback, useEffect, useRef, useState } from 'react';

function useFetchCallback<Args extends any[], Content>(
    requestCallback: (...args: Args) => Promise<{ content: Content } | null>,
) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null as null | Error);
    const isMountedRef = useRef(true);

    useEffect(
        () => () => {
            isMountedRef.current = false;
        },
        [],
    );

    const onFetch = useCallback(
        async (...params: Args) => {
            try {
                setLoading(true);
                setError(null);

                const response = await requestCallback(...params);

                return response?.content || null;
            } catch (e) {
                if (isMountedRef.current) setError(e as Error);

                return null;
            } finally {
                if (isMountedRef.current) setLoading(false);
            }
        },
        [requestCallback],
    );

    return {
        onFetch,
        loading,
        error,
        isMountedRef,
    };
}

export default useFetchCallback;
